import ClientDetails from './ClientDetails'
import AnimalNumbers from './AnimalNumbers'
import ReviewClientDetails from './review/ReviewClientDetails'
import Mastitis from './review/Mastitis'
import ReviewCalving from './review/ReviewCalving'
import ReviewSickCows from './review/ReviewSickCows'
import CalfHealth from './review/CalfHealth'
import DownCowMeta from './review/DownCowMeta'
import TraceElements from './review/TraceElements'
import ReviewReproduction from './review/ReviewReproduction'
import ReviewAmu from './review/ReviewAmu'
import ReviewNsaids from './review/ReviewNsaids'
import ForecastLepto from './review/ForecastLepto'
import ForecastScanning from './review/ForecastScanning'
import ReviewRvmAllocations from './review/ReviewRvmAllocations'
import EmailNotifications from './review/EmailNotifications'
import Disclaimer from './review/Disclaimer'


const springConsultComponents = {
  ClientDetails,
  AnimalNumbers,
}

const springReviewComponents = {
  ClientDetails: ReviewClientDetails,
  Mastitis,
  ReviewCalving,
  ReviewSickCows,
  CalfHealth,
  DownCowMeta,
  TraceElements,
  ReviewReproduction,
  ReviewAmu,
  ReviewNsaids,
  ForecastLepto,
  ForecastScanning,
  ReviewRvmAllocations,
  EmailNotifications,
  Disclaimer,
}

export {
  springConsultComponents,
  springReviewComponents,
}
